import { useFlags } from "launchdarkly-react-client-sdk";

// Default to false for easier testing - change to true for production
const defaultValue = false;

/**
 * Hook to get a boolean feature flag value from LaunchDarkly
 * @param key - The feature flag key
 * @returns The boolean value of the feature flag, defaults to true if not available
 */
export function useBooleanFlag(key: string): boolean {
  const flags = useFlags();

  if (!flags) {
    return defaultValue;
  }

  return flags[key] ?? defaultValue;
}

/**
 * Hook to get a generic feature flag value from LaunchDarkly
 * @param key - The feature flag key
 * @returns The value of the feature flag or undefined if not available
 */
export function useFlag<T>(key: string): T | undefined {
  return useFlags()?.[key];
}

/**
 * Feature flag key for self-triggered questions feature
 * Note: LaunchDarkly converts kebab-case to camelCase in the SDK
 * Dashboard flag key: repath-self-triggered-questions-web
 * SDK flag key: repathSelfTriggeredQuestionsWeb
 */
export const FEATURE_FLAG_SELF_TRIGGERED_QUESTIONS_WEB =
  "repathSelfTriggeredQuestionsWeb";

/**
 * Hook to check if self-triggered questions feature is enabled
 * @returns true if the feature is enabled, false otherwise
 */
export const useSelfTriggeredQuestionsWebFlag = () =>
  useBooleanFlag(FEATURE_FLAG_SELF_TRIGGERED_QUESTIONS_WEB);
